import React from 'react';
import { Marker, Popup, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import './MarkerList.css';

const shadowImage = require('leaflet/dist/images/marker-shadow.png');
const crossImage = require('../../Assets/cross.svg');
const activeCrossImage = require('../../Assets/activecross.svg');

const CustomIcon = L.Icon.extend({
  options: {
    iconSize: [30, 30],
    iconAnchor: [15, 30],
    shadowUrl: shadowImage,
    shadowSize: [30, 30],
    shadowAnchor: [8, 30],
    tooltipAnchor: [1, -30],
    popupAnchor: [0, -30],
  },
});

const crossIcon = new CustomIcon({
  iconUrl: crossImage,
  iconRetinaUrl: crossImage,
  className: 'cross',
});

const activeCrossIcon = new CustomIcon({
  iconUrl: activeCrossImage,
  iconRetinaUrl: activeCrossImage,
  className: 'active cross',
  iconSize: [40, 40],
});

function MarkerList(props) {
  const {
    data, target, setTarget, setActive,
  } = props;

  // const [active, setActive] = useState(false);
  // const [activeKey, setActiveKey] = useState('');


  const filteredChurches = data.filter(church => church.billinglatitude && church.billinglongitude);
  const items = filteredChurches.map(church => (
    <Marker
      key={church.id}
      icon={church.id === target ? activeCrossIcon : crossIcon}
      position={[church.billinglatitude, church.billinglongitude]}
      onClick={() => {
        setTarget(church.id);
        setActive(true);
      }}
      title={church.name}
      className={`${church.id}`}
      zIndexOffset={church.id === target ? 1000 : 0}
    >
      <Tooltip direction="top">{church.name}</Tooltip>
      <Popup onClose={() => setTarget(0)}>{church.name}</Popup>
    </Marker>
  ));

  return (
    <div id="MarkerList">
      {items}
    </div>
  );
}


export default MarkerList;
